// =====================================================================
// App-Liste des Home-Kreises — bildet SHELL_APPS auf Einträge mit Farbe
// und Icon ab. Die Reihenfolge ist zugleich die Position im Kreis.
// =====================================================================

import { SHELL_APPS, type ShellApp } from "../../lib/apps";
import { INSTANCE } from "../../lib/instance";
import { orderBySatellites } from "../../../../shared/instance";
import { getAppLabel, isAppEnabledForInstance } from "../../../../shared/app-catalog";

export interface LauncherApp {
  id: string;
  name: string;
  icon: string; // Pfad zum Icon im Kreis
  color: string;
  route: string;
  shellApp: ShellApp | null;
}

// Farben und Icons aus dem Prototyp — Reihenfolge bestimmt die Position im Kreis.
const LAUNCHER_ENTRIES: Array<{
  id: string;
  appKey: string;
  name: string;
  icon: string;
  color: string;
}> = [
  { id: "notes", appKey: "notes", name: getAppLabel("notes"), icon: "/icons/clean-glass/v1/nexus/icon.svg", color: "#22D77A" },
  { id: "liquid", appKey: "liquid", name: getAppLabel("liquid"), icon: "/icons/clean-glass/v1/liquid/icon.svg", color: "#5BD6A7" },
  { id: "money", appKey: "money", name: getAppLabel("money"), icon: "/icons/clean-glass/v1/money/icon.svg", color: "#5BB8FF" },
  { id: "coorconn-liquid", appKey: "coorconn-liquid", name: getAppLabel("coorconn-liquid"), icon: "/icons/clean-glass/v1/coorconn-liquid/icon.svg", color: "#E87A20" },
  { id: "briefing", appKey: "briefing", name: getAppLabel("briefing"), icon: "/icons/clean-glass/v1/briefing/icon.svg", color: "#5BD6A7" },
  { id: "life", appKey: "life", name: getAppLabel("life"), icon: "/icons/clean-glass/v1/life/icon.svg", color: "#E87CFF" },
  { id: "scan", appKey: "scan", name: getAppLabel("scan"), icon: "/icons/clean-glass/v1/scan/icon.svg", color: "#5BD6E0" },
  { id: "fair", appKey: "fair-kapa", name: getAppLabel("fair-kapa"), icon: "/icons/clean-glass/v1/fair-kapa/icon.svg", color: "#FFB446" },
  { id: "vertrag", appKey: "vertrag", name: getAppLabel("vertrag"), icon: "/icons/clean-glass/v1/vertrag/icon.svg", color: "#F5B544" },

  { id: "back-office", appKey: "back-office", name: getAppLabel("back-office"), icon: "/icons/clean-glass/v1/backoffice/icon.svg", color: "#00A3E0" },
  { id: "regelwerke", appKey: "regelwerke", name: getAppLabel("regelwerke"), icon: "/icons/clean-glass/v1/regelwerke/icon.svg", color: "#7C9CFF" },
  { id: "story", appKey: "story", name: getAppLabel("story"), icon: "/icons/clean-glass/v1/story/icon.svg", color: "#F5A623" },
  { id: "time", appKey: "time", name: getAppLabel("time"), icon: "/icons/clean-glass/v1/time/icon.svg", color: "#41D6EE" },
];

// SATELLITES ordnet und filtert auch den Kreis; ohne Variable bleibt die
// Reihenfolge oben unveraendert.
export const LAUNCHER_APPS: LauncherApp[] = orderBySatellites(
  LAUNCHER_ENTRIES.filter((entry) => isAppEnabledForInstance(entry.appKey, INSTANCE)),
  INSTANCE.satellites,
  (entry) => entry.appKey,
).map((entry) => {
  const shellApp = SHELL_APPS.find((app) => app.appKey === entry.appKey) ?? null;
  return {
    ...entry,
    route: shellApp?.route ?? `/${entry.id}`,
    shellApp,
  };
});
